<div class="overlay">
  <svg viewBox="0 0 696 316" fill="none">
    @for (path of paths; track path.id) {
      <svg:path
          #pathElements
          [attr.d]="path.d"
          stroke="currentColor"
          [attr.stroke-width]="path.width"
          [attr.stroke-opacity]="path.opacity"
      ></svg:path>
    }
  </svg>
</div>